import { Component } from '@angular/core';
@Component({
  templateUrl: './404-page.component.html',
  styleUrls: ['./404-page.component.scss']
})
export class Page404Component {
}
